export default __webpack_public_path__ + "static/media/icon-document.66601804.svg";